export const environment = {
  production: false,
  socketUrl: 'https://api-dev.f2p.net',
  local: false
  // autres variables d'environnement de développement...
};

console.log('Environnement de développement chargé');
